export function splash_video_player() {
  'use strict';

  /*

    Dimensioni img fallback:
    NB: sono utilizzate anche in templates/public-site/_incl/splash_video.incl.html.twig

    dim. pagina    media query         dim. img        flag img
    -------------------------------------------------------------------
    Extra large	   ≥ 1200px            -> 100%      -> senza flag (std) (min-width: 1200px)
    Large	         ≥ 992px ≤ 1199px    -> 780 (65%) -> lg  (min-width: 576px) and (max-width: 1199px)
    Medium 	       ≥ 768px ≤ 991px     -> 700 (70%) -> lg            "
    Small 	       ≥ 576px ≤ 767px     -> 768       -> lg            "
    Extra small	   < 576px             -> 580       -> xs
  */

  const mediaqueries = { // dal più grande al più piccolo
    std: '(min-width: 1200px)',
    lg: '(min-width: 576px) and (max-width: 1999px)',
    xs: '(max-width: 575px)'
  };

  /*
    I file video sono elencati nel preload e sono indicati con l'attributo
    `data-sv-webm`, che può essere 1 o 0

    solo i file mp4 (sempre presenti) hanno l'attributo `data-sv-webm`
    se `data-sv-webm` == 1 esiste anche il file webm
  */

  // let video_meta_data = {},
  //   loading_promises = [];
  const video_wrapper = document.querySelector('.splash-video-wrapper'),
    splash_mode_cookie_name='splash_mode',
    meta_url_risorse = document.querySelector('meta[data-r]'),
    url_risorse = meta_url_risorse? meta_url_risorse.dataset.r : null,
    getSplashModeCookie = () => {
      if(document.cookie.indexOf(splash_mode_cookie_name) !== -1) {
        return document.cookie
          .split('; ')
          .find(row => row.startsWith(splash_mode_cookie_name))
          .split('=')[1];
      } else {
        return false;
      }
    },
    setSplashModeCookie = (val) => { // val == `v` (video) | `i` (imgs)
      let cookie_date = new Date();
      cookie_date.setHours(cookie_date.getHours() + (24 * 60));
      let cookie_parts = [
        `${splash_mode_cookie_name}=${val}`,
        'expires=' + cookie_date.toUTCString(),
        'path=/',
        'SameSite=Lax'
      ];
      document.cookie = cookie_parts.join(';');
    };


  let v_poster = document.querySelector('.v-poster'),
    splash_videos = document.querySelectorAll('link[rel][data-sv-webm]');

  v_poster = v_poster ? v_poster.href : null; // per abilitare il video poster, aggiungere il relativo preload in head

  // play video
  // let ciclo = 0;
  const play_video = idx  => {

      splash_videos[idx].classList.remove('hidden');
      // splash_videos[idx].defaultPlaybackRate = .5;
      splash_videos[idx].play();

    },

    start_videos = () => {
      splash_videos.forEach( (v, idx) => {

        let src = v.href,
          video_tag = '<video controlslist="nodownload nofullscreen"' +
            ' preload="auto" disablePictureInPicture muted'+
            (v_poster ? ` poster="${v_poster}"` : '') +
            ' class="hidden">';

        if(+v.dataset.svWebm) {
          video_tag += `<source src="${src.substring(0, src.lastIndexOf('.'))}.webm" type="video/webm">`;
        }

        video_tag += `<source src="${src}" type="video/mp4"></video>`;

        video_wrapper.insertAdjacentHTML('beforeend', video_tag);

        let this_video = video_wrapper.querySelector('video:last-child'),
          next_idx = idx + 1;
        if(next_idx > splash_videos.length -1) { next_idx = 0; }

        this_video.addEventListener('ended', function() {
          this_video.classList.add('hidden');
          play_video(next_idx);
        }, false);

        // let v_promise = new Promise(function(resolve) {

        //   v.addEventListener('loadedmetadata', (e) => {
        //     video_meta_data[idx].duration =  v.duration % 60;
        //     resolve();
        //   });
        // });

        // loading_promises.push(v_promise);

      });

      splash_videos = video_wrapper.querySelectorAll('video');

      video_wrapper.querySelector('.video-loader').remove();
      play_video(0);
    },

    start_slideshow = () => {
      let imgs_data = document.querySelector('meta[data-simg]').dataset,
        imgs = imgs_data.simg.split('|'),
        vers = imgs_data.v;

      imgs.forEach(img => {

        let img_tag = '<picture>';

        Object.keys(mediaqueries).forEach(fmt => {
          ['webp', 'jpg'].forEach(type => {
            const src = `${url_risorse}/v2/clip-video/screenshots/${img}` +
              `${fmt !== 'std'? `-${fmt}` : ''}.${type}` +
              `?_=${vers}`,
              media = fmt !== 'xs' ? ` media="${mediaqueries[fmt]}"` : '',
              imgtype = type === 'webp'? ' type="image/webp" ' : '';

            // preload (solo delle img non già aggiunte nel twig)
            if(!document.querySelector(`[data-psrc="${img}"]`)) {
              document.head.insertAdjacentHTML('beforeend',
                `<link rel="preload" as="image" href="${src}"` +
                `${media}${imgtype}>`
              );
            }

            // img
            if(fmt === 'xs' && type === 'jpg') {
              img_tag += `<img src="${src}" alt="Schermata videogioco" class="splash-slideshow">`;
            } else {
              img_tag += `<source srcset="${src}"` +
                `${media}${imgtype}>`;
            }
          });
        });

        img_tag += '</picture>';

        video_wrapper.insertAdjacentHTML('beforeend', img_tag);
      });

      video_wrapper.querySelector('.video-loader').remove();
    }
  ;

  let splash_mode_cookie = getSplashModeCookie();

  if(splash_mode_cookie === false) {
    // video di test
    let test_video_src = `${url_risorse}/v2/clip-video/_test.mp4`;
    video_wrapper.insertAdjacentHTML('beforeend',
      `<video id="test_splash_video"
        controlslist="nodownload nofullscreen"
        preload="auto" disablePictureInPicture muted
        ${v_poster ? ` poster="${v_poster}"` : ''}>
        <source src="${test_video_src}" type="video/mp4">
      </video>`
    );

    let playPromise = video_wrapper.querySelector('video').play();

    if (playPromise !== undefined) {
      playPromise.then(() => {
        // Start whatever you need to do only after playback
        setSplashModeCookie('v');
        document.getElementById('test_splash_video').remove();
        start_videos();

      }).catch( () => {
        // if (error.name === 'NotAllowedError') {
        //   console.error('*** Promise error ***'); // eslint-disable-line

        // } else {
        //   // Handle a load or playback error
        //   console.log('*** Promise OK ***'); // eslint-disable-line
        // }
        setSplashModeCookie('i');
        start_slideshow();
      });
    }

  } else if (splash_mode_cookie === 'v') {
    start_videos();

  } else {
    //immagini
    start_slideshow();
  }


}
